<template>

    <div>
<!--        <template v-if="hasPastDueInvoices">-->
<!--            &lt;!&ndash; Handle Past Due Invoices &ndash;&gt;-->
<!--            <h1 class="pb-4">You are not currently subscribed to any plans.</h1>-->
<!--            <p>Please contact <a href="mailto:hello@cat-uxo.com">hello@cat-uxo.com</a> or create a new account and subscribe to a plan.</p>-->
<!--        </template>-->
        <template>
            <!-- Allow user to resubscribe -->
            <subscriptions slot="body" class="mb-5" :plans="plans">
                <a v-if="!loading" v-for="(plan,index) in plans" :key="plan.id" :slot="index === 0 ? 'buttonOne' : 'buttonTwo'"
                   class="btn w-100" :class="{'btn-ghost': form.plan !== plan.id}"
                   @click="form.plan = plan.id">{{ form.plan && form.plan === plan.id ? 'Selected' : 'Choose this plan' }}</a>
            </subscriptions>

            <div v-if="form.plan" class="card p-3 px-2 px-lg-6 mb-3">

                <h1 class="h2 t-orange ml-1 mb-3">Billing Information</h1>

                <form method="POST" action="#" class="#">
                    <div v-if="hasSource" class="columns">
                        <div class="column">
                            <label class="position-relative d-flex align-items-center">
                                <input name="toc" class="input-checkbox" type="checkbox"
                                       v-model.trim="$v.form.existing_payment_method.$model"/>
                                <span class="check-toggle"></span>
                                <span class="toc ml-1 font-weight-light">Use existing payment method for {{localUser.card_brand}} ************{{localUser.card_last_four}}</span>
                            </label>
                        </div>
                    </div>

                    <div class="columns">
                        <div class="column">
                            <div v-if="hasSource" class="fake-border-bottom-1 my-3"></div>
                        </div>
                    </div>

                    <div v-if="errors" class="errors mb-4">
                        <template v-if="Array.isArray(errors)" v-for="(field) in errors">
                            <div v-for="(error) in field" class="error">{{error}}</div>
                        </template>
                    </div>
                    <div class="billing-details d-flex flex-column justify-content-center">
                        <div v-show="! form.existing_payment_method">
                            <div class="columns">
                                <div class="column is-half">
                                    <div class="field mb-4" :class="{ 'has-error': $v.form.billingAddress.$error }">
                                        <label class="label mb-1" for="billingAddress">First line of address*</label>
                                        <div class="control">
                                            <input id="billingAddress" name="billing_address" class="input" type="text"
                                                   v-model.trim="$v.form.billingAddress.$model"/>
                                        </div>
                                        <div class="error" v-if="$v.$dirty && $v.form.billingAddress.$error">
                                            {{getErrorMessage($v.form.billingAddress)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-half">
                                    <div class="field mb-4">
                                        <label class="label mb-1" for="billingAddressLine2">Second line of address</label>
                                        <div class="control">
                                            <input id="billingAddressLine2" name="billing_address_line_2" class="input"
                                                   type="text"
                                                   v-model.trim="$v.form.billingAddressLine2"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-half">
                                    <div class="field mb-4" :class="{ 'has-error': $v.form.billingCountry.$error }">
                                        <label class="label mb-1" for="billingCountry">Country*</label>
                                        <div class="control">
                                            <select id="billingCountry" name="billing_country" class="select"
                                                    v-model.trim="$v.form.billingCountry.$model">
                                                <option :value="null" selected>Country</option>
                                                <option v-for="(country) in countries" :value="country.code">
                                                    {{country.name}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="error" v-if="$v.$dirty && $v.form.billingCountry.$error">
                                            {{getErrorMessage($v.form.billingCountry)}}
                                        </div>
                                    </div>
                                </div>
                                <div class="column is-half">
                                    <div class="field mb-4" :class="{ 'has-error': $v.form.billingPostcode.$error }">
                                        <label class="label mb-1" for="billingPostcode">Postcode*</label>
                                        <div class="control">
                                            <input id="billingPostcode" name="billingPostcode" class="input" type="text"
                                                   v-model.trim="$v.form.billingPostcode.$model"/>
                                        </div>
                                        <div class="error" v-if="$v.$dirty && $v.form.billingPostcode.$error">
                                            {{getErrorMessage($v.form.billingPostcode)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-half">
                                    <div class="field mb-4" :class="{ 'has-error': $v.form.cardholderName.$error }">
                                        <label class="label mb-1" for="cardholderName">Cardholder’s Name*</label>
                                        <div class="control">
                                            <input id="cardholderName" name="cardholder_name" class="input" type="text"
                                                   v-model.trim="$v.form.cardholderName.$model"/>
                                        </div>
                                        <div class="error" v-if="$v.$dirty && $v.form.cardholderName.$error">
                                            {{getErrorMessage($v.form.cardholderName)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column is-full">
                                    <div class="field mb-4">
                                        <div class="mb-1 d-flex align-items-center justify-content-between">
                                            <label for="cardnumber" class="form-group-label required">
                                                Card Details*
                                            </label>
                                            <p class="text-right fs-14 mb-1">{{localUser.card_brand}} ************{{localUser.card_last_four}}</p>
                                        </div>
                                        <div ref="card" class="stripe-card"></div>
                                        <span
                                            id="card-errors"
                                            class="error txt-error mt-1"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column is-offset-3 is-9 is-offset-lg-7 is-lg-5">
                                <div v-if="errors" class="alert alert-error mb-2">{{errors}}</div>

                                <div class="field mx-auto text-right">
                                    <button v-if="!loading" @click.prevent="submit" class="btn btn-form"
                                            :disabled='!resubscribeButtonEnabled'>
                                        Subscribe
                                    </button>
                                    <pulse-loader v-if="loading" :loading="true" :color="'#E57722'"
                                                  :size="'20px'"></pulse-loader>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>

        </template>
    </div>

</template>

<script>
    import {mapGetters, mapState} from "vuex";
    import {axiosWeb,axiosApi} from "@/js/axios";
    import {Card, createToken} from 'vue-stripe-elements-plus';
    import {required} from 'vuelidate/lib/validators';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

    import Subscriptions from '../../Subscriptions';

    import {loadStripe} from '@stripe/stripe-js';

    export default {
        name: 'ReSubscribe',
        components: {
            Subscriptions,
            PulseLoader,
            Card
        },
        props: {
            plans: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                countries: [],

                form: {
                    csrfToken: null,
                    billingAddress: null,
                    billingAddressLine2: null,
                    billingCountry: null,
                    billingPostcode: null,
                    cardholderName: null,
                    billingCard: null,
                    plan: null,
                    source: null,
                    existing_payment_method: false,
                },

                loading: false,
                complete: false,
                errors: false,

                stripe: null,
                elements: null,
                card: null,
            }
        },
        validations() {
            return {
                form: this.rules
            }
        },
        computed: {
            ...mapState('shared', [
                'stripeKey',
                'stripeOptions'
            ]),
            ...mapGetters('form', [
                'getErrorMessage'
            ]),
            ...mapState('user', {
                subscription: 'subscription',
                paying: 'paying_invoices'
            }),
            ...mapGetters('user', {
                localUser: 'activeUser',
                hasPastDueInvoices: 'hasPastDueInvoices'
            }),
            rules() {
                return {
                    billingAddress: {
                        required,
                    },
                    billingCountry: {
                        required,
                    },
                    billingPostcode: {
                        required,
                    },
                    cardholderName: {
                        required,
                    },
                    existing_payment_method: {}
                }
            },
            selectedPlan() {
                return this.form.plan;
            },
            hasSource() {
                return !! (this.localUser && this.localUser.stripe_id && this.localUser.card_last_four);
            },
            resubscribeButtonEnabled() {
                return true;
                // if (this.hasSource && this.selectedPlan) {
                //     return true;
                // }
                // return this.complete;
            }
        },
        watch: {
            selectedPlan: {
                immediate: true,
                deep: true,
                handler(plan) {
                    if (plan) {
                        const $this = this;
                        this.$nextTick(function() {
                            $this.loadStripe();
                        });
                    }
                }
            },
        },
        created() {
            this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
            this.fetchCountries();
        },
        methods: {
            async loadStripe() {
                this.stripe = await loadStripe(this.stripeKey);

                this.elements = this.stripe.elements();
                this.card = this.elements.create('card', {style: this.style});
                this.card.mount(this.$refs.card);
            },

            fetchCountries() {
                return axiosApi.get(`/api/v1/countries`)
                    .then(response => {
                        if (response.data) {
                            this.countries = response.data.data
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },

            submit() {
                const $this = this;

                if (! this.form.existing_payment_method) {
                    $this.$v.form.$touch();
                    if ($this.$v.form.$invalid) {
                        return;
                    }
                }

                $this.loading = true;
                $this.form.plan = $this.selectedPlan;

                if (this.form.existing_payment_method) {
                    this.resubscribe();
                } else {
                    this.createCardTokenAndResubscribe();
                }
            },

            createCardTokenAndResubscribe() {
                const $this = this;

                this.stripe.createToken(this.card).then(function(data) {
                    if (data.error) {
                        $this.loading = false;

                        // Inform the user if there was an error.
                        let errorElement = document.getElementById('card-errors');
                        errorElement.textContent = data.error.message;
                        return;
                    }

                    data.token.card.name = $this.form.cardholderName;
                    data.token.card.address_line1 = $this.form.billingAddress;
                    data.token.card.address_line2 = $this.form.billingAddressLine2;
                    data.token.card.address_country = $this.form.billingCountry;
                    data.token.card.address_zip = $this.form.billingPostcode;

                    $this.form.source = data.token;

                    $this.resubscribe();
                });
            },

            resubscribe() {
                const $this = this;
                return axiosWeb.post(`/api/v1/resubscribe`, $this.form)
                    .then( ({data}) => {
                        if (data.status === 'incomplete' && data.paymentIntent.status === 'requires_action') {
                            $this.authorizeCardPayment(data.paymentIntent);
                        } else {
                            let toast = Vue.toasted.show("Your subscription has been updated successfully.", {
                                theme: "toasted-primary",
                                type: 'success',
                                icon: 'done',
                                position: "top-center",
                                duration: 6000,
                                className: 'shadow-modal rounded-lg font-primary p-2',
                            });

                            setTimeout(function () {
                                window.location.href = '/settings/billing';
                            }, 2000);
                        }
                    })
                    .catch((error) => {
                        $this.loading = false;
                        if (error.response.status === 402) { // Payment Failed
                            // Inform the user if there was an error.
                            let errorElement = document.getElementById('card-errors');
                            errorElement.textContent = error.response.data.error.message;
                        }
                })
            },

            authorizeCardPayment(paymentIntent) {
                const $this = this;
                this.stripe.confirmCardPayment(paymentIntent.client_secret, {
                    payment_method: paymentIntent.source
                })
                    .then(function(result) {
                        if (result.hasOwnProperty('error')) {
                            return $this.failSubscriptionAttempt(paymentIntent.client_secret, result.error.message);
                        }

                        if (result.hasOwnProperty('paymentIntent')) {
                            return $this.updateAccount(paymentIntent.client_secret);
                        }
                    })
                    .catch((error) => {
                        $this.failSubscriptionAttempt(paymentIntent.client_secret);
                    });
            },

            updateAccount(clientSecret) {
                const $this = this;
                this.form['payment_intent_id'] = clientSecret;
                return axiosWeb.put(`/api/v1/update/subscriber`, $this.form)
                    .then(({data}) => {
                        let toast = Vue.toasted.show("Your subscription has been updated successfully.", {
                            theme: "toasted-primary",
                            type: 'success',
                            icon: 'done',
                            position: "top-center",
                            duration: 6000,
                            className: 'shadow-modal rounded-lg font-primary p-2',
                        });
                        setTimeout(function () {
                            window.location.href = '/settings/billing';
                        }, 2000);
                    });
            },

            failSubscriptionAttempt(clientSecret, errorMessage) {
                axiosWeb.put(`/api/v1/pending-subscriber/${clientSecret}`);
                this.loading = false;
                let errorElement = document.getElementById('card-errors');
                errorElement.textContent = errorMessage;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/settings/ReSubscribe.vue